import {useFeatureIsOn} from "@growthbook/growthbook-react";

import {useFlagsCookie} from "@khan/data-cookies";

import type {AppFeatures} from "./app-features.ts";

// Since GrowthBook useFeatureIsOn doesn't support forcing via cookies, this
// func is a workaround to check both the flag and the cookie, similar to
// our old flag system.
export function useFlagOrCookie(flagName: keyof AppFeatures): boolean {
    const featureFlag = useFeatureIsOn<AppFeatures>(flagName);
    const flagsCookieResult = useFlagsCookie(flagName);
    const flagsCookie =
        flagsCookieResult.status === "success"
            ? flagsCookieResult.value
            : undefined;

    const flag = Boolean(featureFlag || flagsCookie);

    return flag;
}
